import createCachedSelector from 're-reselect';

import { getDefaultNotificationsEditorState } from '../../service/NotificationEditorHelper/NotificationEditorHelper';
import { NotificationEditorsState, NotificationEditorState } from '../../typings/notificationEditor';
import { State } from '../../typings/state';

export const selectNotificationsEditorValue = createCachedSelector(
    (state: State) => state.notificationEditor,
    (state: State, editorId: string) => editorId,
    (editors: NotificationEditorsState, editorId: string): NotificationEditorState => {
        return editors[editorId] || getDefaultNotificationsEditorState();
    }
)((state: State, editorId: string) => editorId);
